import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';

async function mountCtaBlocks() {
	const ctaBlocks = [...document.querySelectorAll('[data-cta-block]')];

	if (!ctaBlocks.length) {
		console.warn('[CtaBlocks] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	await Promise.all(
		Array.from(ctaBlocks).map(async (item, index) => {
			const app = createApp({
				name: `CtaBlocksApp-${index}`,
			});
			app.component(
				'cta-block',
				defineAsyncComponent(
					() =>
						import(
							/* webpackChunkName: "cta-block" */ 'shared/components/articleElements/ctaBlock.vue'
						),
				),
			);

			app.component(
				'cta-button-with-popup-form',
				defineAsyncComponent(
					() =>
						import('shared/components/actionButtonWithCTA/CtaButtonWithPopupForm.vue'),
				),
			);
			app.component(
				'form-kit-builder-container',
				defineAsyncComponent(
					() =>
						import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue'),
				),
			);
			await initFormKitSchema(app, options);
			app.use(store);
			app.mount(item);
		}),
	);
}

mountCtaBlocks().catch((error) => {
	console.error('Error mounting CtaBlocks:', error);
});
